/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useRef, useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useOnClickOutside } from "../../../CommonMethods/OutsideClick"; 
import { useSelector } from "react-redux";
import Filter from "./Filter";

const TopBar = ({
    notFound,
    handleOnClickSearch,
    SearchValue,
    handleApplyFilter,
    searchParams,
    createPath,
    handleFilters,
    handleExport,
    sidePane,
    handleSetDate,
    DateRange,
    SetDateRange,
    setsubmitSelected,
    setSearchParams,
    DateRangeError,
    SetDateRangeError,
    handleDatePickerValidation,
    DateErrorClear,
    productFilter
}) => {
    const location = useNavigate();
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const outSideClick = useRef();
    const [isSearchVisible, setIsSearchVisible] = useState(false);
    const [timer, setTimer] = useState(null);
    const [search, setSearch] = useState(SearchValue);

    const initailState = {
        dataRange: { from_date : '', end_date: '' },
    }

    const handleSearch = (newValue) => {
        setSearch(newValue);
        clearTimeout(timer);
        const newTimer = setTimeout(() => {
            handleOnClickSearch("search", newValue)
        }, 500)
        setTimer(newTimer)
    }
    useOnClickOutside(outSideClick, () => {
        setIsFilterOpen(false);
    });
    const [loading, setloading] = useState(false);

   

    const store = JSON.parse(localStorage.getItem('Store'));
    const { List } = useSelector(state => state.Orders);

    return (
        <>
            <div className="bg-white flex pt-7 justify-between items-center px-8 pr-[66px] gap-2">
                <div className='pt-8 mb-8 flex justify-between items-center'>
                </div>
                {(List?.data?.length !== 0 || (param.from_date || param.end_date)) && !notFound  && <div className="flex justify-center items-center space-x-10">
                    <Filter
                        setIsFilterOpen={setIsFilterOpen}
                        isFilterOpen={isFilterOpen}
                        handleOnClickSearch={handleFilters}
                        handleSetDate={handleSetDate}
                        DateRange={DateRange}
                        handleApplyFilter={handleApplyFilter}
                        DateRangeError={DateRangeError}
                        SetDateRangeError={SetDateRangeError}
                        DateErrorClear={DateErrorClear}
                        handleDatePickerValidation={handleDatePickerValidation}
                        productFilter={productFilter}
                    />
                </div>}
            </div>
        </>
    );
};

export default TopBar;
